import { render, staticRenderFns } from "./DosageHospital.vue?vue&type=template&id=4a89dfac&scoped=true&"
import script from "./DosageHospital.vue?vue&type=script&lang=js&"
export * from "./DosageHospital.vue?vue&type=script&lang=js&"
import style0 from "./DosageHospital.vue?vue&type=style&index=0&id=4a89dfac&lang=scss&scoped=true&"
import style1 from "./DosageHospital.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89dfac",
  null
  
)

export default component.exports